const paddingSessions = '0 3px 3px 3px'

// export const FullHeight = {
//     height: 'calc(100% - 32px)'
// }

export const Container = {
    // ...FullHeight,
    height: '100%',
    width: '100%'
    // border: '1px solid white'
}

export const SessaoMonitoramento = {
    // border: '2px solid red',
    height: '100%',
    padding: paddingSessions
}

export const RightSessionSx = {
    height: '100%',
    width: '100%',
    padding: paddingSessions,
    display: 'flex',
    flexDirection: 'column'
}

export const SessaoCond = {
    // border: '2px solid green',
    height: '100%'
}

const heightGridCameras = 260
export const GridCamerasSx = {
    // border: '1px solid red',
    height: `${heightGridCameras}px`
}

const heightGridMonitoramento = `calc(100% - ${heightGridCameras}px)`
export const GridMonitoramento = {
    // border: '1px solid yellow',
    display: 'flex',
    width: '100%',
    height: `${heightGridMonitoramento}`
}

export const GridNaoAtendidos = {
    // border: '1px solid white',
    padding: '3px',
    height: '100%'
}

export const GridEmAtendimento = {
    // border: '1px solid white',
    padding: '3px',
    height: '100%'
}

const heightTitleBoxMonitoramento = 15
export const TitleBoxMonitoramento = {
    // border: '1px solid red',
    height: `${heightTitleBoxMonitoramento}px`,
    fontSize: '11px',
    display: 'flex',
    gap: 1
}

export const GridAguardando = {
    // border: '1px solid red',
    padding: '3px',
    height: {
        xs: '100%',
        lg: '50%'
    }
}

export const IconTitleBoxMonitoramento = {
    fontSize: '13px'
}

const BoxPadraoEventos = {
    padding: '3px',
    height: `calc(100% - ${heightTitleBoxMonitoramento}px)`,
    background: '#FFFFFF',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    overflowY: 'auto',
    flexWrap: 'nowrap'
}

export const BoxNaoAtendidos = {
    ...BoxPadraoEventos
    // border: '1px solid purple'

}

export const BoxEmAtendimento = {
    ...BoxPadraoEventos
    // border: '1px solid purple'
}

const heightBoxEmEspera = `calc(100% - ${heightTitleBoxMonitoramento}px)`

export const BoxEmEspera = {
    ...BoxPadraoEventos,
    // border: '1px solid purple',
    // display: 'flex',
    // flexDirection: 'column',
    height: heightBoxEmEspera
}

const heightNumeroVersao = 20
export const GridNumeroCond = {
    width: "100%",
    height: `calc(100% - ${heightNumeroVersao}px)`,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    fontSize: '15px'
    // borderTop: '1px solid white'
    // border: '1px solid yellow'
}

export const GridPesquisaCond = {
    border: '1px solid red'
}

export const GridNumeroVersao = {
    width: "100%",
    height: `${heightNumeroVersao}px`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '11px',
    // fontFamily: 'Segoe UI',
    textShadow: '1px 1px black'
    // border: '1px solid red'
}

export const NumeroCondButton = {
    height: '25px',
    width: '100%'
}

export const GridEventosPadrao = {
    fontWeight: 400,
    padding: '4px'
}

export const GridInfoEventos = {
    ...GridEventosPadrao,
    // border: '1px solid red',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
}

export const GridInfoEventosValue = {
    fontWeight: 700,
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}

export const GridOpcaoEventos = {
    ...GridEventosPadrao
    // border: '1px solid green'
}

export const InfoEventoTextArea = {
    width: '100%',
    height: 'calc(100% - 15px)',
    resize: 'none',
    borderRadius: '5px',
    padding: 0,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '13px',
    overflowY: 'auto'
}

export const BtnLogEvento = {
    width: '20px',
    height: '20px',
    borderRadius: '5px',
    backgroundColor: '#D9D9D9',
    color: 'black',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
}

export const GridBtnLogEvento = {
    // border: '1px solid black',
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 0.8
}

export const LogEventoTextArea = {
    ...InfoEventoTextArea,
    height: '100%',
    overflowY: 'auto'
}
